/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Oct 2021
 * @flow
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

import constants from '../../../../globalization';
import PopupHeader from '../PopupHeader';
import Button from '../../../../components/Button';
import Voucher from './Voucher';
import VoucherInput from './VoucherInput';
import styles from './Redeem.module.css';

const RedeemVoucher = props => {
  const {
    onClosePopup,
    onRedeemVoucher,
    selectedCheck,
    currency,
    iso2,
  } = props;
  const { vouchers } = selectedCheck || {};
  const [state, setState] = useState({
    first4Digit: '',
    last4Digit: '',
    managerLoginId: '',
    showLogin: false,
  });

  const handleInputChange = key => event => {
    const value = event.target.value;
    console.log(key, value)
    if (key) {
      setState((prevState) => {
        return {
          ...prevState,
          [key]: value,
        };
      });
    }
  };

  const redeemCode = () => {
    onRedeemVoucher && onRedeemVoucher('redeemCode', { first: state.first4Digit, last: state.last4Digit });
  };

  const managerOverride = () => {
    onRedeemVoucher && onRedeemVoucher('managerOverride', { employeeCode: state.managerLoginId });
  };

  const toggleManagerLogin = value => {
    setState((prevState) => {
      return {
        ...prevState,
        showLogin: value,
      };
    });
  };

  const renderScanToRedeem = () => {
    const voucher0 = (Array.isArray(vouchers) && vouchers.length) ? vouchers[0] : {};
    const { status } = voucher0 || {};
    return (
      <Voucher
        check={selectedCheck}
        currency={currency}
        iso2={iso2}
      >
        <Button
          className={styles.button}
          disabled={status !== 0}
          onClick={() => onRedeemVoucher && onRedeemVoucher('scanToRedeem')}>
          <span className={styles.btnText}>{constants.scanToRedeem}</span>
        </Button>
      </Voucher>
    );
  };

  const renderManagerOverride = () => {
    return (
      <div className={styles.boxWrapper}>
        <span className={styles.boxTitle}>{constants.enterYourLoginId}</span>
        <span className={styles.closeIcon} onClick={() => toggleManagerLogin(false)}>X</span>
        <input
          placeholder='Login ID'
          value={state.managerLoginId}
          onChange={handleInputChange('managerLoginId')}
          className={styles.input} />
        <div className={styles.buttonWrapper}>
          <Button
            className={styles.loginButton}
            disabled={state.managerLoginId.trim().length === 0}
            onClick={managerOverride}>
            <span className={styles.btnText}>{constants.loginLabel}</span>
          </Button>
        </div>
      </div>
    );
  };

  const renderRedeemCode = () => {
    const voucher0 = (Array.isArray(vouchers) && vouchers.length) ? vouchers[0] : {};
    const { status } = voucher0 || {};
    return (
      <div className={styles.boxWrapper}>
        <span className={styles.boxTitle}>{constants.enterVoucherCode}</span>
        <VoucherInput
          first4Digit={state.first4Digit}
          last4Digit={state.last4Digit}
          handleInputChange={handleInputChange}
        />
        <div className={styles.buttonWrapper}>
          <Button
            className={styles.button}
            disabled={status !== 0}
            onClick={() => toggleManagerLogin(true)}>
            <span className={styles.btnText}>{constants.managerOverride}</span>
          </Button>
          <Button
            className={styles.button}
            disabled={(status !== 0) || (state.first4Digit.trim().length < 4) || (state.last4Digit.trim().length < 4)}
            onClick={redeemCode}>
            <span className={styles.btnText}>{constants.redeemCode}</span>
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <PopupHeader containerStyle={styles.headerWrapper} onClose={onClosePopup} />
      {renderScanToRedeem()}
      {state.showLogin ? renderManagerOverride() : renderRedeemCode()}
    </div>
  );
};

export default RedeemVoucher;

RedeemVoucher.propTypes = {
  onClosePopup: PropTypes.func,
  onRedeemVoucher: PropTypes.func,
  selectedCheck: PropTypes.object,
  currency: PropTypes.string,
  iso2: PropTypes.string,
};

RedeemVoucher.defaultProps = {
  onClosePopup: () => { },
  onRedeemVoucher: () => { },
  selectedCheck: {},
  currency: '$',
  iso2: 'US',
};
